export default "__VITE_ASSET__C$z3e3KV__$_?format=webp__"